import { render, staticRenderFns } from "./FolderStructureIndexing.vue?vue&type=template&id=51a3772e&scoped=true&"
import script from "./FolderStructureIndexing.vue?vue&type=script&lang=js&"
export * from "./FolderStructureIndexing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a3772e",
  null
  
)

export default component.exports